import { getLoadedEntryBundle } from "@/lib/checkForUpdate";

const CHUNK_ERROR =
  /Importing a module script failed|Failed to fetch dynamically imported module|ChunkLoadError|Loading chunk .+ failed/i;

type RecoveryOptions = {
  entryBundle?: string | null;
  storage?: Pick<Storage, "getItem" | "setItem">;
  reload?: () => void;
};

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return CHUNK_ERROR.test(`${error.name}: ${error.message}`);
}

/**
 * Uma aba aberta durante um deploy ainda aponta para chunks do bundle anterior.
 * Recarrega no máximo uma vez POR BUNDLE DE ORIGEM; se o bundle novo também
 * falhar, a ErrorBoundary mantém a tela de retry em vez de entrar em loop.
 */
export function recoverFromChunkLoadError(
  error: unknown,
  options: RecoveryOptions = {},
): boolean {
  if (!isChunkLoadError(error)) return false;

  try {
    const entryBundle = options.entryBundle === undefined
      ? getLoadedEntryBundle()
      : options.entryBundle;
    const storage = options.storage ?? window.sessionStorage;
    const reload = options.reload ?? (() => window.location.reload());
    const key = `ondiet_chunk_reload_from_${entryBundle ?? "unknown"}`;

    if (storage.getItem(key)) return false;
    storage.setItem(key, "1");
    reload();
    return true;
  } catch {
    return false;
  }
}
